/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-container[_ngcontent-%COMP%]{display:flex;flex-direction:column}#publishCheckbox[_ngcontent-%COMP%]{padding-bottom:15px}.red-background[_ngcontent-%COMP%]{background-color:#ffcfd6}.mat-dialog-content[_nghost-%COMP%], .mat-dialog-content   [_nghost-%COMP%]{background-color:#ffcfd6}"];
export { styles as styles };
